<template>
    <div id="plan-list" class="bg-grey">

        <div class="bg-fff" id="productsList">
            <search-box :keyword="filter.keyword" @search="filterChange" @changeImgSearchHandle="changeImgSearchHandle" :isListPage=true></search-box>
            <homepage-children :isListShow=true :isShowImgSearch="isShowImgSearch"></homepage-children>
            <div v-if="!localImgSearch" :class="getScrollData ? 'filter-header-fixed-con' : '' ">
                <filter-header :class="getScrollData ? 'filter-header-fixed' : ''" :filter="filter" type="plan"
                               @filterChange="filterChange"></filter-header>
            </div>
        </div>
        <listContent type="plan" :list="plans" @load="loadMore" :local-img-search="localImgSearch" :keyword="filter.keyword" :busy="busy"></listContent>
    </div>
</template>
<style>
    .list .ivu-col {
        float: left;
    }
</style>
<script>
    import myCascader from '../../../../../src/components/common/myCascader.vue'
    import searchBox from '../../../../../src/components/common/searchBox.vue'
    import {mapGetters} from 'vuex'
    import api from '../../../../../src/api/index'
    import {constructQueryParams, deconstructUrl} from '../../../../../src/api/common'
    import homepageChildren from '../../../../../src/components/common/homePageChildrenTop.vue';
    import listContent from '../../../../../src/components/common/listContent.vue'
    import filterHeader from '../../../../../src/components/common/filterHeader.vue'

    export default {
        data() {
            return {
                baseImgUrl: api.common.imgBaseUrl,
                filter: {
                    roomType: '',
                    style: '',
                    sort: '',
                    keyword: '',
                    pageNum: 1,
                    pageSize: 20
                },
                total: 0,
                plans: [],
                busy: false,
                ended: false,
                localImgSearch:this.$route.query.imgsearch,
                isShowImgSearch: true
            }
        },
        components: {
            myCascader,
            searchBox,
            homepageChildren,
            listContent,
            filterHeader
        },
        computed: {
            ...mapGetters([
                'roomTypes',
                'styles',
                'sorts'
            ]),
            getScrollData() {
                return this.$store.state.app.scrollRollData;
            }
        },
        methods: {
            changeImgSearchHandle(){
                this.updateList();
            },
            updateList(params) {
                this.busy = true;
                if(this.localImgSearch === undefined){
                    api.plans.getPlans(params)
                        .then(res => {
                            this.plans =this.plans.concat(res.list).filter(item=>!!item.coverFile);
//                        this.plans =res.list.filter(item=>!!item.coverFile);
                            this.busy = false;
                            this.total = res.total;
                        }, () => {
                            this.busy = false;
                        })
                }else{
                    this.plans = [];
                    let params = {
                        'imageUrl': this.baseImgUrl +localStorage.getItem("imgSearchLocal"),
                        'searchType': 2
                    }
                    api.account.searchUrl(params)
                        .then(res => {
                            this.plans = res.list || [];
                            this.busy = false;
                        }, () => {
                            this.busy = false;
                        })
                }

            },
            filterChange(type, value) {
                this.isShowImgSearch=false;
                this.localImgSearch = undefined;
                if (type === 'keyword') {
                    Object.assign(this.filter, {
//                        roomType: '',
//                        style: '',
//                        sort: '',
                        keyword: value,
                        pageNum: 1,
                        pageSize: 20
                    });
                    window.history.pushState({}, '住逻辑', window.location.href.split('?')[0] + constructQueryParams(this.filter));
                    this.$router.go(0);
                } else {
                    this.filter[type] = value;
                    window.history.pushState({}, '住逻辑', window.location.href.split('?')[0] + constructQueryParams(this.filter));
                    this.init();
                    this.updateList(this.filter);
                }
            },
            init() {
                this.filter.pageNum = 1;
                this.plans = [];
            },
            loadMore: function () {
                if (this.filter.pageNum * this.filter.pageSize < this.total) {
                    this.filter.pageNum++;
                    this.updateList(this.filter);
                }
            }
        },
        created() {
            let searchParams = deconstructUrl(window.location.search);
            if (searchParams) {
                for (let item in this.filter) {
                    this.filter[item] = searchParams[item] || this.filter[item];
                }
            }
            this.updateList(this.filter);
        }
    };
</script>
